// /src/components/TabButtons.js
import React from 'react';

function TabButtons({ activeTab, setActiveTab }) {
  const tabs = ["background", "text", "assets", "layers", "deepFry", "eraser"];

  return (
    <div className="flex gap-2 mb-4 ml-36 justify-center max-md:ml-0">
      {tabs.map((tabKey) => {
        const label = tabKey[0].toUpperCase() + tabKey.slice(1); // "Background", "Text", etc.
        return (
          <button
            key={tabKey}
            onClick={() => setActiveTab(tabKey)}
            className={`px-3 py-1 rounded ${
              activeTab === tabKey
                ? "bg-monadAccent text-white"
                : "bg-monadDark text-white"
            } max-md:px-1 max-md:py-0 max-md:text-sm max-md:leading-none max-md:h-11`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}

export default TabButtons;
